module.exports = __WEBPACK_EXTERNAL_MODULE_162__;


//////////////////
// WEBPACK FOOTER
// external "node-pty"
// module id = 162
// module chunks = 0